import {
  BundleContentItemType,
  IBundle,
  IService,
  LanguageKeys,
  VehicleType,
} from "../entities/interface";

export const getSortableServiceList = (
  bundles: Array<IBundle>,
  ser: IService[]
): IBundle[] => {
  bundles.map((service) => {
    if (service.productType === "Bundle") {
      const bundle = service as IBundle;

      let bundleIds = bundle.content.map((ser) => ser.id);
      bundle.content.map((b) => {
        const service = ser.find((s) => s.id === b.id);
        b.name = {
          en:
            b?.type === BundleContentItemType.Theory
              ? "Theory"
              : service?.name.en || "",
          sw:
            b?.type === BundleContentItemType.Theory
              ? "Teori"
              : service?.name.sw || "",
        };
      });
      if (bundleIds.length > 0) {
        const bundleServices = ser?.filter((ser) => bundleIds.includes(ser.id));
        const bundleServicesVehicleTypes = new Set(
          bundleServices?.map((v) => v.vehicleType)
        );
        const bundleServicesLanguage = new Set(
          bundleServices
            ?.map((v) => v.languageCode)
            .filter((v) => v && v.length)
        );

        if (bundleServicesVehicleTypes.size > 1) {
          service.vehicleType = undefined;
        } else if (bundleServicesVehicleTypes.has(VehicleType.Car)) {
          service.vehicleType = VehicleType.Car;
        } else if (bundleServicesVehicleTypes.has(VehicleType.Mc)) {
          service.vehicleType = VehicleType.Mc;
        } else if (bundleServicesVehicleTypes.has(VehicleType.Moped)) {
          service.vehicleType = VehicleType.Moped;
        }

        if (
          bundleServicesLanguage.size > 1 ||
          bundleServicesLanguage.size === 0
        ) {
          service.languageCode = undefined;
        } else if (bundleServicesLanguage.has(LanguageKeys.English)) {
          service.languageCode = LanguageKeys.English;
        } else if (bundleServicesLanguage.has(LanguageKeys.Swedish)) {
          service.languageCode = LanguageKeys.Swedish;
        }
      }
    }
  });

  return bundles;
};

export const sortBundles = (
  a: IBundle,
  b: IBundle,
  lng: LanguageKeys,
  ids: number[]
) => {
  const key = lng === LanguageKeys.English ? "en" : "sw";
  if (ids.includes(b.id)) {
    return 1;
  } else if (
    a.name[key].replace(/[0-9]/g, "") < b.name[key].replace(/[0-9]/g, "")
  ) {
    return 1;
  } else if (
    a.name[key].replace(/[0-9]/g, "") > b.name[key].replace(/[0-9]/g, "")
  ) {
    return -1;
  } else {
    return a.priceWithVat - b.priceWithVat;
  }
};
